/**
 * Created by Daniela on 19/10/2016.
 */
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import {DivisaoListComponent} from "./divisao-list/divisao-list.component";
import {DivisaoFormComponent} from "./divisao-form/divisao-form.component";
import {editRoute, newRoute} from "../../shared/services/data.service";

@NgModule({
  imports: [
    RouterModule.forChild([])
  ],
  exports: [
    RouterModule
  ]
})
export class DivisoesRoutingModule {}


export const divisoesRoutes: any[] = [
  {
    path: '',
    component: DivisaoListComponent
  },{
    path: editRoute + '/:id',
    component: DivisaoFormComponent
  },{
    path: newRoute,
    component: DivisaoFormComponent
  }
];



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/divisoes/divisoes-routing.module.ts
 **/